import React from 'react';
import { LoadScript } from '@react-google-maps/api';

const LoadScriptWrapper = ({ children }) => {
  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={libraries}>
      {children}
    </LoadScript>
  );
};

const libraries = ['places'];

export default LoadScriptWrapper;
